import { render, staticRenderFns } from "./ConceptList.vue?vue&type=template&id=6582af28&scoped=true"
import script from "./ConceptList.vue?vue&type=script&lang=js"
export * from "./ConceptList.vue?vue&type=script&lang=js"
import style0 from "./ConceptList.vue?vue&type=style&index=0&id=6582af28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582af28",
  null
  
)

export default component.exports